<template>
  <div class="donation-form insicht insicht--fade-up">
    <form
      class="donation-form__wrapper"
      novalidate
      @submit.prevent="onSubmit"
    >
      <h2
        v-if="title"
        class="donation-form__title"
        v-sanitize="title"
      />
      <h3
        v-if="subtitle"
        class="donation-form__subtitle"
        v-sanitize="subtitle"
      />
      <GeneralMessage
				ref="message"
				v-if="response.message"
				:message="response.message"
				:type="response.type"
				stick
			/>
      <div class="donation-form__amount">
        <span
          class="donation-form__amount-prefix"
          v-html="'CHF'"
        />
        <input
          class="donation-form__amount-input"
          v-model.number="amount"
          type="number"
          min="0"
          step="1"
          autocomplete="off"
          :disabled="formLocked"
          @blur="onBlur"
        >
      </div>
      <Button
        type="submit"
        level="primary"
        :text="$t('donation.orderButton')"
        :disabled="submitLocked"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { mapGetters } from "vuex"
import scrrroll from 'scrrroll'
import FormInput from "@/components/FormInput"
import FormInputSelect from "@/components/FormInputSelectCustom"
import GenericMixin from '@/mixins/GenericVueMixin'
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		FormInputSelect,
		Button,
		GeneralMessage,
	},
  props: {},
  data() {
    return {
      title: this.$root.options.title,
      subtitle: this.$root.options.subtitle,
      amount: null,
      response: {
				type: 'info',
				message: '',
			},
    }
  },
  computed: {
    ...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
    formLocked() {
      return this.loading
    },
    submitLocked() {
      return this.formLocked || !this.amount || this.amount <= 0
    }
  },
  methods: {
    onBlur() {
      this.amount = this.$options.filters.fwgpricecent(this.amount * 100, 'short')
    },
    async onSubmit(e) {
			e.preventDefault();
      this.onBlur()
			this.loading = true;

			if (this.amount) {
				try {
          this.response.message = ''
          this.response.type = 'info'

					await this.$store.dispatch('cart/createDonationOrder', {
						amount: this.amount * 100
					});
				}
				catch(err) {
          this.isDebug() && console.error(err);
          if (err.isMaintenanceError) {
            this.onMaintenanceMode({ callback: () => this.onSubmit(e), retry: true })
          } else {
            if (err.response && err.response.data.message) {
              this.response.message = err.response.data.errors && Object.values(err.response.data.errors).length
                ? Array.from(new Set(Object.values(err.response.data.errors).flat())).join()
                : err.response.data.message
            } else {
              this.response.message = this.$t('forms.errors.generic');
            }
            this.response.type = 'error';
            this.$nextTick(() => {
              this.$refs.message.scrollTo();
            });
          }
					this.loading = false;
				}
			} else {
				await this.$nextTick();
				const inputError = this.$refs.form.$el.querySelector('.input-error');

				if (inputError) {
					scrrroll.to(inputError.parentNode)
				}
				this.loading = false
			}
		},
  }
}
</script>
